import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MenuComponent } from '../menu.component';

@Component({
    selector: 'ez-member-menu',
    template: require('./member-menu.component.html'),
    styles: [require('./member-menu.component.less')]
})
export class MemberMenuComponent extends MenuComponent {
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/member/member-menu.component.ts